<script>
import Icon from '@/components/Icon';

export default {
  name: 'whatsapp-push-tariffs-table-column',
  components: {
    Icon
  },
  props: {
    label: String,
    channel: String,
    isMau: Boolean,
    planRecordId: Number
  },
  computed: {
    mauDescription: vm => (vm.isChannelPush ? 'fe.mau.description.push' : 'fe.mau.description'),
    service() {
      switch (this.channel) {
        case 'PUSH':
          return 'fe.push.service';
        case 'EMAIL':
          return 'fe.email.service';
        case 'WHATSAPP':
          return 'fe.whatsapp.service';
        default:
          return '';
      }
    }
  }
};
</script>

<template>
  <div>
    <template v-if="isMau">
      {{ $t(label) | capitalize }}
      <el-tooltip placement="top-start">
        <div class="tariffs__tooltip" slot="content">{{ $t(mauDescription) }}</div>
        <Icon class="tariffs__question-icon" width="16" height="16" viewBox="0 0 16 16" iconName="question-icon" />
      </el-tooltip>
    </template>
    <template v-else-if="planRecordId">
      {{ $t(service) | capitalize }}
    </template>
    <div class="tariffs__fee-description" v-else>
      {{ $t('fe.subsciption.fee') | capitalize }}
      <el-tooltip placement="top-start">
        <div class="tariffs__tooltip" slot="content">{{ $t('fe.tariffs.fee.hint.2') }}</div>
        <icon class="tariffs__question-icon" width="16" height="16" viewBox="0 0 16 16" iconName="question-icon" />
      </el-tooltip>
    </div>
  </div>
</template>
